import { render, staticRenderFns } from "./Liquidations.vue?vue&type=template&id=28717430&scoped=true&"
import script from "./Liquidations.vue?vue&type=script&lang=js&"
export * from "./Liquidations.vue?vue&type=script&lang=js&"
import style0 from "./Liquidations.vue?vue&type=style&index=0&id=28717430&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28717430",
  null
  
)

export default component.exports